import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// import List from "@material-ui/core/List";
// import ListItem from "@material-ui/core/ListItem";
// @material-ui/icons
// import Mail from "@material-ui/icons/Mail";
// import Favorite from "@material-ui/icons/Favorite";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
// import CustomInput from "components/CustomInput/CustomInput.jsx";
import Footer from "components/Footer/Footer.jsx";

// import face1 from "assets/img/faces/card-profile6-square.jpg";
// import face2 from "assets/img/faces/christian.jpg";
// import face3 from "assets/img/faces/card-profile4-square.jpg";
// import face4 from "assets/img/faces/card-profile1-square.jpg";
// import face5 from "assets/img/faces/marc.jpg";
// import face6 from "assets/img/faces/kendall.jpg";
// import face7 from "assets/img/faces/card-profile5-square.jpg";
// import face8 from "assets/img/faces/card-profile2-square.jpg";

import styles from "assets/jss/material-kit-pro-react/views/componentsSections/footerStyle.jsx";

const SectionFooter = props => {
  const { classes } = props;
  return (
    <div className={classes.section}>
      <div>
        <Footer
          // theme="white"
          content={
            <div>
              <ul className={classes.socialButtons}>
                <li>
                  <Button justIcon simple href="https://twitter.com/webBananaUniteT" color="twitter">
                    <i className="fab fa-twitter" />
                  </Button>
                </li>
                <li>
                  <Button justIcon simple href="https://www.youtube.com/user/BusinessGear" color="youtube">
                    <i className="fab fa-youtube" />
                  </Button>
                </li>
              </ul>
              <div
                className={classNames(classes.pullCenter, classes.copyRight)}
              >
                &copy; 2014-{1900 + new Date().getYear()}{" "}
                WEB BANANA UNITE Tokyo-Yokohama Limited Partnership Company
              </div>
            </div>
          }
        >
          <div className={classes.footer}>
            <GridContainer>
            <GridItem xs={12} sm={2} md={2}>
                <h5>About</h5>
                <ul className={classes.linksVertical}>
                  <li>
                    <a href="/whoWeAre.html">Who we are</a>
                  </li>
                  <li>
                    <a href="/whatWeWill.html">What we will</a>
                  </li>
                  <li>
                    <a href="/contactUs.html">Contact us</a>
                  </li>
                  <li>
                    <a href="/goroku/">Blog</a>
                  </li>
                </ul>
              </GridItem>
              <GridItem xs={12} sm={3} md={3}>
                <a href="/ipad/index.html">
                  <h5>システム手帳</h5>
                  <p>子供のころからの手帳へのあこがれをカタチに。</p>
                  <h6>おかげさまで40万ダウンロード！</h6>
                </a>
                <p>
                ＜機能＞<br/>
                ・手書きメモ帳<br/>
                ・iCloud共有スケジュール帳<br/>
                ・ファイルビューア<br/>
                </p>
              </GridItem>
              <GridItem xs={12} sm={5} md={5}>
                <h5>システム</h5>
                <ul className={classes.linksVertical}>
                    <li><a href="/smartContract.html">ブロックチェーンP2Pオーバーレイネットワーク構築</a></li>
                    <li><a href="/web/drm_video_system.html">楕円曲線暗号公開鍵（ECDSA）によるビデオ動画デジタル著作権管理システム（DRM）開発</a></li>
                    <li><a href="/ipad/sip_webrtc.htm">オンライン診療ソフトウェア</a></li>
                    <li><a href="/software/sk_kokyaku_kanri.htm">メールから顧客専用掲示板へシフトしてスパムメールのない仕事環境へ</a></li>
                </ul>
              </GridItem>
              <GridItem xs={12} sm={2} md={2}>
                <h5>アプリケーション</h5>
                <ul className={classes.linksVertical}>
                    <li><a href="/ipad/systemTecyou.html">システム手帳</a></li>
                    <li><a href="/ipad/GoodNightOnYouTube.htm">萌えキュン時計</a></li>
                    <li><a href="/ipad/health_check.htm">Fitbit健康管理</a></li>
                    <li><a href="/ipad/camera.htm">カメラ画像加工</a></li>
                    <li><a href="/ipad/speech_recognition.htm">音声認識自動翻訳</a></li>
                    <li><a href="/ipad/publicity_app.htm">SNS＋宣伝広告アプリ</a></li>
                    <li><a href="/ipad/video_picture_app.htm">動画＋GSP地図情報アプリ</a></li>
                </ul>
              </GridItem>
              {/* <GridItem xs={12} sm={3} md={3}>
                <h5>Subscribe to Newsletter</h5>
                <p>
                  Join our newsletter and get news in your inbox every week! We
                  hate spam too, so no worries about this.
                </p>
                <form>
                  <CustomInput
                    id="footeremail"
                    formControlProps={{
                      fullWidth: false
                    }}
                    inputProps={{
                      placeholder: "Your Email..."
                    }}
                  />
                  <Button color="primary" justIcon>
                    <Mail />
                  </Button>
                </form>
              </GridItem> */}
            </GridContainer>
          </div>
        </Footer>
      </div>
    </div>
  );
};

export default withStyles(styles)(SectionFooter);



// WEBPACK FOOTER //
// ./src/views/SectionsPage/Sections/SectionFooter.jsx